import React, { useEffect } from 'react';
import {
  Label, 
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import Services from './services';
import _ from 'lodash';
import { DatetimePicker} from '../../../commons/controls';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import moment from 'moment';

const AlkalmakForm = props => {
  let selected = false;

  const {
    formAlkalmak,
    formTeremkiosztas,
    formTerem, 
    helyszinId,
    jegySWExists,
    handleSelectInputChange,
    handleChangeAlkalomInput,
    handleChangeAlkalomDateInput,
    removeAlkalom,
    penznemOptions,
    kenyelmiDijParam,
    kenyelmiDijInputChecker,
  } = props;

  useEffect(() => {
    setDefaultPenznem();
  }, []);

  const loadTeremkiosztasOptions = (input, callback) => {
    Services.listTeremkiosztas(helyszinId, formTeremkiosztas && formTeremkiosztas.kod, (err, res) => {
      if (!err) {
        let options = [];
        if(res[0][helyszinId]){
          res[0][helyszinId].filter( tk => tk.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
            options.push(item);
          });
        }
        callback(options);
      }
    });
  }

  const loadTeremOptions = (input, callback) => {
    Services.listTeremSelect(helyszinId, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( t => t.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadTulajdonsagOptions = (input, callback) => {
    Services.listTulajdonsag((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( t => t.leiras.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const setDefaultPenznem = () => {
    Services.getDefaultPenznem((err, res) => {
      if (!err) {
        handleChangeAlkalomInput(null, res[0], "penznem");
      }
    });
  }

  const loadEsemenyTipusOptions = (input, callback) => {
    Services.listEsemenyTipus((err, res) => {
      if (!err) {
        let options = [];
        res[0].list.filter( e => e.cap.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const handleDateChange = (e,v,type,esemenytipus,idx) => {
    if(selected) {
      selected = false;
      let date = moment(e).startOf('day');
      switch (type) {
        case 'FORMESEMENYKEZDETE':
          // Igény, hogy ha már töltve van az időpont, akkor onnantól kezdve ne legyen nullázva dátum választáskor
          if (formAlkalmak[idx]?.esemenykezdete != null) {
            date = moment(e);
          }
          handleChangeAlkalomDateInput(date, "esemenykezdete", esemenytipus, idx);
          break;
        case 'FORMESEMENYVEGE':
          handleChangeAlkalomDateInput(date, "esemenyvege", esemenytipus, idx);
          break;
        case 'FORMFOGLALASKEZDETE':
          handleChangeAlkalomDateInput(date, "foglalaskezdete", esemenytipus, idx);
          break;
        case 'FORMFOGLALASVEGE':
          handleChangeAlkalomDateInput(date, "foglalasvege", esemenytipus, idx);
          break;
        case 'FORMVASARLASKEZDETE':
          handleChangeAlkalomDateInput(date, "vasarlaskezdete", esemenytipus, idx);
          break;
        case 'FORMVASARLASVEGE':
          handleChangeAlkalomDateInput(date, "vasarlasvege", esemenytipus, idx);
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMESEMENYKEZDETE':
          handleChangeAlkalomDateInput(v === '' ? v : e, "esemenykezdete", esemenytipus, idx);
          break;
        case 'FORMESEMENYVEGE':
          handleChangeAlkalomDateInput(v === '' ? v : e, "esemenyvege", esemenytipus, idx);
          break;
        case 'FORMFOGLALASKEZDETE':
          handleChangeAlkalomDateInput(v === '' ? v : e, "foglalaskezdete", esemenytipus, idx);
          break;
        case 'FORMFOGLALASVEGE':
          handleChangeAlkalomDateInput(v === '' ? v : e, "foglalasvege", esemenytipus, idx);
          break;
        case 'FORMVASARLASKEZDETE':
          handleChangeAlkalomDateInput(v === '' ? v : e, "vasarlaskezdete", esemenytipus, idx);
          break;
        case 'FORMVASARLASVEGE':
          handleChangeAlkalomDateInput(v === '' ? v : e, "vasarlasvege", esemenytipus, idx);
          break;
        default:
          break;
      }
    }
  }

  const defaultInputs =
    <div className="row" key={0}>
      <div className="col-md-12" style={{ marginBottom: '20px' }}>
        {jegySWExists ? 
          <React.Fragment>
            <SelectField
              variant='async'
              label='Teremkiosztás:'
              styles={{
                control: base => ({
                  marginBottom: '20px'
                }),
              }}
              id={"formTeremkiosztas"}
              name={"formTeremkiosztas"}
              isDisabled={formAlkalmak.map(a => a.id) > 0}
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, "formTeremkiosztas")}
              loadOptions={_.debounce(loadTeremkiosztasOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.kod}
              value={formTeremkiosztas}
              cache={false}
              isClearable
              defaultOptions
            />
          </React.Fragment>
        :
          <React.Fragment>
            <SelectField
              variant='async'
              label='Terem:'
              styles={{
                control: base => ({
                  ...base,
                  marginBottom: '20px'
                }),
              }}
              id={"formTerem"}
              name={"formTerem"}
              isDisabled={formAlkalmak.map(a => a.id) > 0}
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={(e, v) => handleSelectInputChange(v, e, "formTerem")}
              loadOptions={_.debounce(loadTeremOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formTerem}
              cache={false}
              isClearable
              defaultOptions
            />
          </React.Fragment>}
      </div>
    </div>;

  const renderAlkalmak = () => {
    let alkalmak = [defaultInputs];
    
    formAlkalmak.forEach( (item, idx) => {
      const disabled = !!item.id;
      const backgroundColor = disabled ? "#d3dee3" : "" ;

      alkalmak.push(
        <span key={item.id} className="row border rounded" style={{ marginBottom: 10, paddingTop: 10 ,marginLeft: 10, marginRight: 10, paddingBottom: 10, backgroundColor: backgroundColor }}>
          <div className="col-md-4">
            <SelectField
              label='Esemény típusa:'
              variant='async'
              styles={{
                control: base => ({
                  ...base,
                  marginBottom: '20px'
                }),
              }}
              id={"esemenyTipus"}
              name={"esemenyTipus"}
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={(e, v) => handleChangeAlkalomInput(v, e, "esemenytipus", idx)}
              loadOptions={_.debounce(loadEsemenyTipusOptions, 1000)}
              getOptionLabel={option => option.cap}
              getOptionValue={option => option.nam}
              value={item.esemenytipus}
              cache={false}
              isClearable
              defaultOptions
            />
          </div>
          <div className="col-md-4">
            <SelectField
              variant='async'
              label='Tulajdonság:'
              styles={{
                control: base => ({
                  ...base,
                  marginBottom: '20px'
                }),
              }}
              id={"tulajdonsag" + idx}
              name={"tulajdonsag" + idx}
              isDisabled={disabled}
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={(e, v) => handleChangeAlkalomInput(v, e, "tulajdonsagid", idx)}
              loadOptions={_.debounce(loadTulajdonsagOptions, 1000)}
              getOptionLabel={option => option.leiras || option.megjelenes || option.azonosito}
              getOptionValue={option => option.id}
              value={item.tulajdonsagEntity && item.tulajdonsagEntity.id}
              cache={false}
              isClearable
              defaultOptions
            />
          </div>
          <div className="col-md-2">
              <RFField
                label={'Max. jegyszám: '}
                pattern="^[0-9]*$"
                name={"maxjegyszam" + idx}
                id={"maxjegyszam" + idx}
                type="text"
                value={item.maxjegyszam}
                disabled={disabled}
                onChange={(e,v) => handleChangeAlkalomInput(e, v, "maxjegyszam", idx)}
              />
          </div>
          <div className="col-md-auto" style={{marginTop: "34px"}}>
            <RFField 
              label={'Publikus'}
              type="checkbox" 
              name={"publikus" + idx}
              value={item.publikus}
              disabled={disabled}
              onChange={(e,v) => handleChangeAlkalomInput(e, v, "publikus", idx)}
            />
          </div>
          <div className="col-md-2">
            <SelectField
              label='Pénznem:'
              styles={{
                control: base => ({
                  ...base,
                  '&:focus': { borderColor: 'red' }, // border style on hover
                  border: '1px solid lightgray', // default border color
                  boxShadow: 'none', // no box-shadow
                  borderRadius: '0',
                  marginBottom: '20px'
                }),
              }}
              id={"formPenznem"}
              name={"formPenznem"}
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleChangeAlkalomInput(null, v, "penznem", idx)}
              //loadOptions={_.debounce(loadPenznemOptions, 1000)}
              options={penznemOptions}
              getOptionLabel={option => option.azonosito}
              getOptionValue={option => option.id}
              value={item.penznem}
              cache={false}
              isClearable
              defaultOptions
            />
          </div>
          {kenyelmiDijParam && <>
            <div className="col-md-2">
              <RFField
                label='Kényelmi díj összege: '
                regex={['^[0-9\.]*$', 'Számokat tartalmazó mező!']} 
                name={"kenyelmidij" + idx}
                id={"kenyelmidij" + idx}
                type="text"
                value={item.kenyelmidij}
                disabled={disabled}
                autoComplete="off"
                onKeyDown={(e) => {
                  if (!kenyelmiDijInputChecker(e, e.target.value, item.penznem?.tizedesjegy))
                    e.preventDefault();
                }}
                onChange={(e,v) => {
                  if (kenyelmiDijInputChecker(e, v, item.penznem?.tizedesjegy))
                    handleChangeAlkalomInput(e, v, "kenyelmidij", idx)}
                }
              />
            </div>
            <div className="col-md-2">
              <RFField
                label={'Kényelmi díj %: '}
                regex={['^[0-9\.]*$', 'Számokat tartalmazó mező!']} 
                name={"kenyelmidijsz" + idx}
                id={"kenyelmidijsz" + idx}
                type="text"
                value={item.kenyelmidijsz}
                disabled={disabled}
                autoComplete="off"
                onKeyDown={(e) => {
                  if (!kenyelmiDijInputChecker(e, e.target.value, 2))
                    e.preventDefault();
                }}
                onChange={(e,v) => {
                  if (kenyelmiDijInputChecker(e, v, 2))
                    handleChangeAlkalomInput(e, v, "kenyelmidijsz", idx)}
                }
              />
            </div>
          </>}
          <div className="col-md-auto">
            <RFField
              label={'Rendelés időlimit (perc): '}
              pattern="^[0-9]*$"
              name={"formRendelesIdoLimit"}
              id={"formRendelesIdoLimit"}
              type="text"
              disabled={disabled}
              value={item.rendelesidolimit}
              onChange={(e,v) => handleChangeAlkalomInput(e, v, "rendelesidolimit", idx)}
            />
          </div>
          <div className="col-md-auto">
            <div>
              <Label for={"formRendelesTorlesIdoLimit"} >Rendelés törlés időlimit (perc): 
                <i
                  style={{ marginTop: 0 }}
                  id={"formRendelesTorlesIdoLimitInfo"}
                  aria-label="Ha az érték negatív, akkor az előadás kezdete előtt törlődnek a foglalások/vásárlások."
                  className="fa fa-info-circle table-action-icon transp-icon-button"
                />
                <UncontrolledTooltip trigger='hover focus-visible'
                  placement="top"
                  target={"formRendelesTorlesIdoLimitInfo"}
                  delay={0}
                >
                  {' Ha az érték negatív, akkor az előadás kezdete előtt törlődnek a foglalások/vásárlások.'}
                </UncontrolledTooltip>
              </Label>
              <RFField
                pattern="^-?[0-9]*$"
                name={"formRendelesTorlesIdoLimit"}
                id={"formRendelesTorlesIdoLimit"}
                type="text"
                disabled={disabled}
                value={item.rendelestorlesidolimit}
                onChange={(e,v) => handleChangeAlkalomInput(e, v, "rendelestorlesidolimit", idx)}
              />
            </div>
          </div>
          <div className="col-md-5">
            <DatetimePicker
              label={'Előadás kezdete: '}
              required
              id={"esemenyKezdete" + idx}
              name={"esemenyKezdete" + idx}
              value={item.esemenykezdete && new Date(item.esemenykezdete)}
              disabled={disabled}
              // onChange={(e,v) => handleChangeAlkalomDateInput(v, "esemenyKezdete", idx)}
              onChange={(e,v) => {handleDateChange(e,v,'FORMESEMENYKEZDETE', item.esemenytipus?.nam, idx)}}
              onSelect={(e,v) => { selected = true }}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-5">
            <DatetimePicker
              label={'Előadás vége: '}
              required
              id={"esemenyVege" + idx}
              name={"esemenyVege" + idx}
              value={item.esemenyvege && new Date(item.esemenyvege)}
              disabled={disabled}
              // onChange={(e,v) => handleChangeAlkalomDateInput(v, "esemenyVege", idx)}
              onChange={(e,v) => handleDateChange(e,v,'FORMESEMENYVEGE', item.esemenytipus?.nam, idx)}
              onSelect={(e,v) => { selected = true }}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-5">
            <DatetimePicker
              label={'Foglalás kezdete: '}
              required
              id={"foglalasKezdete" + idx}
              name={"foglalasKezdete" + idx}
              value={item.foglalaskezdete && new Date(item.foglalaskezdete)}
              disabled={!item.esemenytipus?.nam || item.esemenytipus?.nam === 'VASAROLHATO' || disabled}
              onChange={(e,v) => handleDateChange(e,v,'FORMFOGLALASKEZDETE', item.esemenytipus?.nam, idx)}
              onSelect={(e,v) => { selected = true }}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-5">
            <DatetimePicker
              label={'Foglalás vége: '}
              required
              id={"foglalasVege" + idx}
              name={"foglalasVege" + idx}
              value={item.foglalasvege && new Date(item.foglalasvege)}
              disabled={!item.esemenytipus?.nam || item.esemenytipus?.nam === 'VASAROLHATO' || disabled}
              onChange={(e,v) => handleDateChange(e,v,'FORMFOGLALASVEGE', item.esemenytipus?.nam, idx)}
              onSelect={(e,v) => { selected = true }}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-5">
            <DatetimePicker
              label={'Értékesítés kezdete: '}
              required
              id={"vasarlasKezdete" + idx}
              name={"vasarlasKezdete" + idx}
              value={item.vasarlaskezdete && new Date(item.vasarlaskezdete)}
              disabled={!item.esemenytipus?.nam || item.esemenytipus?.nam === 'FOGLALHATO' || disabled}
              onChange={(e,v) => handleDateChange(e,v,'FORMVASARLASKEZDETE', item.esemenytipus?.nam, idx)}
              onSelect={(e,v) => { selected = true }}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-5">
            <DatetimePicker
              label={'Értékesítés vége: '}
              required
              id={"vasarlasVege" + idx}
              name={"vasarlasVege" + idx}
              value={item.vasarlasvege && new Date(item.vasarlasvege)}
              disabled={!item.esemenytipus?.nam || item.esemenytipus?.nam === 'FOGLALHATO' || disabled}
              onChange={(e,v) => handleDateChange(e,v,'FORMVASARLASVEGE', item.esemenytipus?.nam, idx)}
              onSelect={(e,v) => { selected = true }}
              timePrecision="seconds"
            />
          </div>
          <div className="col-md-1">
            <Button color="secondary" style={{ marginTop: '28px', width: "100%" }} type="button" onClick={e => removeAlkalom(idx)}>
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        </span>
      )
    });
    return alkalmak;
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderAlkalmak()}
      </div>
    </div>
  );
}

export default AlkalmakForm;
